const dayjs = require("dayjs");

export const convertToMap = (listOfObjects, key) => {
  return listOfObjects.reduce((acc, item) => {
    acc[item[key]] = item;
    return acc;
  }, {});
};

export const sortByDescending = (listOfObjects, key) => {
  return listOfObjects.sort((a, b) => (dayjs(a[key]) > dayjs(b[key]) ? -1 : 1));
};

export const sortByAscending = (listOfObjects, key) => {
  return listOfObjects.sort((a, b) => (dayjs(a[key]) > dayjs(b[key]) ? 1 : -1));
};
